<template>
  <!-- 在线考试页面 -->
  <section class="container">
    <div class="wrapper TestM">
      <div class="header flex-row">
        <div class="col-33 text-left">{{ examTitle }}</div>
        <div class="col-34 text-center">倒计时：{{ countminute }}:{{ countsecond }}</div>
        <div class="col-33 text-right relative">
          考生：{{ realName }}
          <div class="All text-center" :class="$store.state.fixed ? 'fixed' : ''">
            <div class="videoM" v-if="isCamera">
              <div class="relative">
                <video class="video" id="video" width="240" height="180" autoplay></video>
                <p>
                  <Icon type="ios-alert" />您已经在摄像头监控范围内
                </p>
                <p>请勿切换屏幕和在他人指导下考试.</p>
              </div>
              <canvas v-show="false" id="canvas" width="240" height="180"></canvas>
            </div>
            <div class="sum text-left">
              <div
                class="col-10 text-center"
                v-for="(answer, index) in answerData"
                :key="index"
                @click
              >
                <a
                  :href="'#anchor' + index"
                  :class="[answer.userAnswer != '' || answer.userAnswers != '' ? 'answerBlue' : '']"
                >{{ index + 1 }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="innerM">
        <div class="inner-wrapper text-left">
          <div class="single" v-for="(questionlist, index) in dataList" :key="index">
            <div
              class="title2"
            >{{ questionlist.exerciseBlockId }}、{{ questionlist.title }}。（共{{ questionlist.totalNumber }}题，合计{{ questionlist.totalScore }}分）</div>
            <div
              class="subject"
              v-for="(question, index1) in questionlist.questionList"
              :key="index1"
            >
              <div class="question">
                <a :id="'anchor' + question.topicId" class="anchor"></a>
                [{{ questionlist.title }}]&nbsp;{{ question.questionTitle }}（{{ question.score }}分）
              </div>
              <!--单选题-->
              <RadioGroup
                v-model="answerList[index][index1].userAnswer"
                v-if="questionlist.questionType == 1"
              >
                <img
                  :src="questionlist.questionList[index1].imgUrl"
                  v-show="questionlist.questionList[index1].imgUrl"
                  style="width:750px;height:450px;display:block;background-size: 100% 100%"
                />
                <div
                  class="options"
                  v-for="(option, index2) in question.questionOptionList"
                  :key="index2"
                >
                  <Radio :label="option.sort">
                    <span>{{ option.title }}</span>
                  </Radio>
                </div>
              </RadioGroup>
              <!--多选题-->
              <CheckboxGroup
                v-model="answerList[index][index1].userAnswers"
                v-if="questionlist.questionType == 2"
              >
                <img
                  :src="questionlist.questionList[index1].imgUrl"
                  v-show="questionlist.questionList[index1].imgUrl"
                  style="width:750px;height:450px;display:block;background-size: 100% 100%"
                />
                <div
                  class="options"
                  v-for="(option, index2) in question.questionOptionList"
                  :key="index2"
                >
                  <Checkbox :label="option.sort">
                    <span>{{ option.title }}</span>
                  </Checkbox>
                </div>
              </CheckboxGroup>
              <!--单判断题-->
              <RadioGroup
                v-model="answerList[index][index1].userAnswer"
                v-if="questionlist.questionType == 3"
              >
                <img
                  class="image"
                  :src="questionlist.questionList[index1].imgUrl"
                  v-show="questionlist.questionList[index1].imgUrl"
                  style="width:750px;height:450px;display:block;background-size: 100% 100%"
                />
                <div class="options">
                  <Radio label="1">
                    <span>对</span>
                  </Radio>
                </div>
                <div class="options">
                  <Radio label="0">
                    <span>错</span>
                  </Radio>
                </div>
              </RadioGroup>
            </div>
          </div>
        </div>
        <div class="submit">
          <Button type="primary" size="large" @click="modal3 = true" v-if="showSubBtn">提交试卷</Button>
        </div>
      </div>
    </div>
    <Modal v-model="modal3" @on-ok="sendAnswer">
      <h2 style="padding: 25px 0;" class="text-center">{{ modal3content }}</h2>
    </Modal>
    <!-- modal add -->
    <Modal title="提示" v-model="showModal" :closable="false" :mask-closable="false">
      <p style="margin:10px 0;">考试已结束，系统已经强制交卷，后台正在评分，点击查看分数。</p>
      <div slot="footer">
        <Button type="primary" size="large" @click="checkGrade">查看</Button>
      </div>
    </Modal>
    <!-- modal2 add -->
    <Modal title="提示" v-model="showModal2" :closable="false" :mask-closable="false">
      <p style="margin:10px 0;">试卷已经提交，后台正在评分，点击查看分数。</p>
      <div slot="footer">
        <Button type="primary" size="large" @click="checkGrade">查看</Button>
      </div>
    </Modal>
    <!-- modal add wp -->
    <el-dialog title="考试结果" :visible.sync="resultDialog" width="460px" @close="examEnd">
      <div class="resultlist">
        <div class="result">
          <p>{{ result.notAnswerNumber }}</p>
          <p>未答题数</p>
        </div>
        <div class="result">
          <p>{{ result.score }}</p>
          <p>考试得分</p>
        </div>
        <div class="result">
          <p>{{ result.errorAnswerNumber }}</p>
          <p>错题数</p>
        </div>
      </div>
      <p class="remark">{{ result.remark }}</p>
      <span slot="footer" class="dialog-footer">
        <el-button type="success" @click="examEnd">确 认</el-button>
      </span>
    </el-dialog>
    <Footer></Footer>
  </section>
</template>
<script>
import Footer from "./components/Footer";
var i = 0;
export default {
  name: "Examination",
  data() {
    return {
      showSubBtn: true,
      autoSend: "", //断网定时提交
      isFullScreen: false, //是否处于全屏
      realName: "",
      handinflag: 0, //是否提交成绩
      answerDuration: 0, //倒计时
      totalTime: "", //总时间
      countTimeout: "", //倒计时延时器配合watch
      switchLimit: 0, //网页切换次数限制
      dataList: [], //接口初始数据
      answerList: [], //配合题目的答案列表
      answered: 0, //已答题数
      answerData: [], //接口需要的答案列表
      examTitle: "",
      result: {}, //考试结果
      resultDialog: false,
      modal3: false,
      modal3content: "检测到您还有未答的题目，是否提交试卷",
      noshow: false,
      isCamera: false,
      ShotCount: 0,
      screenShotTime: "", //截图延时器
      showModal: false,
      showModal2: false,
      isSelfSend: 0, //是否主动提交 主动提交后为1
      goTime: 0 //截图判断时间
    };
  },
  mounted() {
    var that = this;
    that.onload();
    that.setTab();
    that.countTime();
  },
  created() {
    var that = this;
  },
  watch: {
    answerList: {
      handler(newValue, oldValue) {
        var that = this;
        var tmp = [];
        for (var i = 0; i < newValue.length; i++) {
          tmp = tmp.concat(newValue[i]);
        }
        that.answerData = tmp;
      },
      deep: true
    },
    answerData: {
      handler(newValue, oldValue) {
        var that = this;
        var count = 0;
        for (var i = 0; i < newValue.length; i++) {
          var tmp = newValue[i];
          if (tmp.userAnswer != "" || tmp.userAnswers != "") {
            count += 1;
          }
        }
        if (count == that.answerData.length) {
          that.modal3content = "是否提交试卷";
        }
        that.answered = count;
      },
      deep: true
    },
    answerDuration: function(newQuestion, oldQuestion) {
      var that = this;
      if (newQuestion > 0) {
        that.countTimeout = window.setTimeout(function() {
          newQuestion--;
          that.answerDuration = newQuestion;
        }, 1000);
      } else {
        //去掉定时器的方法
        window.clearTimeout(that.countTimeout);
        if (that.isSelfSend === 0) {
          that.forceSendAnswer();
        }
      }
    }
  },
  computed: {
    countminute: function() {
      //倒计时--分
      var that = this;
      var num = parseInt(that.answerDuration / 60);
      if (num < 10) {
        num = "0" + num;
      }
      return num;
    },
    countsecond: function() {
      //倒计时--秒
      var that = this;
      var num = that.answerDuration % 60;
      if (num < 10) {
        num = "0" + num;
      }
      return num;
    }
  },
  methods: {
    onload() {
      //初始化
      var that = this;
      var token = that.$cookie.get("xjaf-token");
      var username = that.$cookie.get("xjaf-user");
      if (token != null && username != null) {
        this.httprequest();
      } else {
        this.$router.push("/Online");
      }
    },
    countTime() {
      var that = this;
      that.goTime++;
      setTimeout(function() {
        that.countTime();
      }, 1000);
    },
    httprequest() {
      var that = this;
      this.$http({
        url: that.webhost + "exam/getPaper/" + that.$route.params.examId,
        method: "POST"
      }).then(({ data }) => {
        if (data && data.code === 0) {
          var tmp = data.data.blockList;
          for (var i = 0; i < tmp.length; i++) {
            switch (i) {
              case 0:
                tmp[i].exerciseBlockId = "一";
                break;
              case 1:
                tmp[i].exerciseBlockId = "二";
                break;
              case 2:
                tmp[i].exerciseBlockId = "三";
                break;
              case 3:
                tmp[i].exerciseBlockId = "四";
                break;
              case 4:
                tmp[i].exerciseBlockId = "五";
                break;
              case 5:
                tmp[i].exerciseBlockId = "六";
                break;
              case 6:
                tmp[i].exerciseBlockId = "七";
                break;
              case 7:
                tmp[i].exerciseBlockId = "八";
                break;
              case 8:
                tmp[i].exerciseBlockId = "九";
                break;
              case 9:
                tmp[i].exerciseBlockId = "十";
                break;
              case 10:
                tmp[i].exerciseBlockId = "十一";
                break;
              case 11:
                tmp[i].exerciseBlockId = "十二";
                break;
              case 12:
                tmp[i].exerciseBlockId = "十三";
                break;
              case 13:
                tmp[i].exerciseBlockId = "十四";
                break;
              case 14:
                tmp[i].exerciseBlockId = "十五";
                break;
              case 15:
                tmp[i].exerciseBlockId = "十六";
                break;
              case 16:
                tmp[i].exerciseBlockId = "十七";
                break;
              case 17:
                tmp[i].exerciseBlockId = "十八";
                break;
              case 18:
                tmp[i].exerciseBlockId = "十九";
                break;
              case 19:
                tmp[i].exerciseBlockId = "二十";
                break;
              case 20:
                tmp[i].exerciseBlockId = "二十一";
                break;
              case 21:
                tmp[i].exerciseBlockId = "二十二";
                break;
              case 22:
                tmp[i].exerciseBlockId = "二十三";
                break;
              case 23:
                tmp[i].exerciseBlockId = "二十四";
                break;
              case 24:
                tmp[i].exerciseBlockId = "二十五";
                break;
              case 25:
                tmp[i].exerciseBlockId = "二十六";
                break;
              case 26:
                tmp[i].exerciseBlockId = "二十七";
                break;
              case 27:
                tmp[i].exerciseBlockId = "二十八";
                break;
              case 28:
                tmp[i].exerciseBlockId = "二十九";
                break;
              case 29:
                tmp[i].exerciseBlockId = "三十";
                break;
            }
          }
          that.dataList = that.loadanswered(tmp);
          that.examId = data.data.examId;
          that.examTitle = data.data.examTitle;
          that.takePhoto = data.data.takePhoto;
          that.answerDuration = data.data.answerDuration - 5;
          that.totalTime = data.data.answerDuration;
          that.realName = data.data.realName;
          that.switchLimit = data.data.switchLimit;
          if (that.takePhoto && that.takePhoto === 1) {
            that.isCamera = true;
            that.openCamera();
          }
          if (data.data.switchLimitFlag && data.data.switchLimitFlag === 1) {
            //判断网页是否失去焦点事件---在全屏的前提下判断
            window.onblur = function(e) {
              var path = that.$route.path;
              if (path.indexOf("Examination") === 1 && that.isFullScreen) {
                that.checkPage();
              }
            };
          }
          that.checkFullscreen();
          that.shieldRight();
          that.$Modal.info({
            title: "考试须知",
            content: "考试过程中必须保证网页全屏状态！",
            onOk: () => {
              var path = that.$route.path;
              if (path.indexOf("Examination") === 1) {
                that.launchFullscreen();
              }
            }
          });
        } else if (data && data.code === 1) {
          that.$router.push("/Online");
        } else {
          that.$router.push("/Online");
          that.$Message.error(data.msg);
        }
      });
    },
    shieldRight() {
      //屏蔽右键菜单
      var that = this;
      var path = that.$route.path;
      document.oncontextmenu = function(e) {
        if (path.indexOf("Examination") === 1) {
          return false;
        } else {
          return true;
        }
      };
    },
    checkFullscreen() {
      //检测全屏状态
      var that = this;
      document.addEventListener("fullscreenchange", function(e) {
        // console.log("fullscreenchange", e);
        var path = that.$route.path;
        if (
          path.indexOf("Examination") === 1 &&
          !e.currentTarget.IsFullScreen
        ) {
          // console.log("全屏状态", e.currentTarget.IsFullScreen);
          that.isFullScreen = false;
          that.checkPage();
        } else if (
          path.indexOf("Examination") === 1 &&
          e.currentTarget.IsFullScreen
        ) {
          that.isFullScreen = true;
        }
      });
      document.addEventListener("mozfullscreenchange", function(e) {
        // console.log("mozfullscreenchange ", e);
        var path = that.$route.path;
        if (
          path.indexOf("Examination") === 1 &&
          !e.currentTarget.mozIsFullScreen
        ) {
          // console.log("全屏状态", e.currentTarget.mozIsFullScreen);
          that.isFullScreen = false;
          that.checkPage();
        } else if (
          path.indexOf("Examination") === 1 &&
          e.currentTarget.mozIsFullScreen
        ) {
          that.isFullScreen = true;
        }
      });
      document.addEventListener("webkitfullscreenchange", function(e) {
        var path = that.$route.path;
        if (
          path.indexOf("Examination") === 1 &&
          !e.currentTarget.webkitIsFullScreen
        ) {
          // console.log("全屏状态", e.currentTarget.webkitIsFullScreen);
          that.isFullScreen = false;
          that.checkPage();
        } else if (
          path.indexOf("Examination") === 1 &&
          e.currentTarget.webkitIsFullScreen
        ) {
          that.isFullScreen = true;
        }
      });
      document.addEventListener("msfullscreenchange", function(e) {
        // console.log("msfullscreenchange", e);
        var path = that.$route.path;
        if (
          path.indexOf("Examination") === 1 &&
          !e.currentTarget.msIsFullScreen
        ) {
          // console.log("全屏状态", e.currentTarget.msIsFullScreen);
          that.isFullScreen = false;
          that.checkPage();
        } else if (
          path.indexOf("Examination") === 1 &&
          e.currentTarget.msIsFullScreen
        ) {
          that.isFullScreen = true;
        }
      });
    },
    launchFullscreen() {
      //判断各种浏览器，找到正确的方法 进入全屏
      var element = document.documentElement;
      if (element.requestFullscreencreen) {
        element.requestFullScreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullScreen) {
        element.webkitRequestFullScreen();
      } else if (element.msRequestFullScreen) {
        element.msRequestFullScreen();
      }
    },
    exitFullscreen() {
      //判断浏览器种类 退出全屏
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    },
    checkPage() {
      var that = this;
      var checkCount = that.$cookie.get("checkCount");
      if (that.answerDuration > 0) {
        //以秒为单位设置cookie
        function setCookie(cname, cvalue, exdays) {
          var exp = new Date();
          exp.setTime(exp.getTime() + 1000 * exdays); // 默认是存在24小时 * 7天
          document.cookie =
            cname + "=" + cvalue + ";expires=" + exp.toGMTString() + ";path=/";
        }
        if (checkCount == null) {
          checkCount = 1;
          setCookie("checkCount", checkCount, that.answerDuration);
          that.$Modal.warning({
            title: "考试警告",
            content:
              "检测到您目前已经切换了" +
              checkCount +
              "次网页，次数到达" +
              that.switchLimit +
              "次时，将进行强制交卷，请在考试过程中保证全屏模式。",
            onOk: () => {
              var path = that.$route.path;
              if (path.indexOf("Examination") === 1) {
                that.launchFullscreen();
              }
            }
          });
        } else if (checkCount < that.switchLimit - 1) {
          checkCount++;
          setCookie("checkCount", checkCount, that.answerDuration);
          that.$Modal.warning({
            title: "考试警告",
            content:
              "检测到您目前已经切换了" +
              checkCount +
              "次网页，次数到达" +
              that.switchLimit +
              "次时，将进行强制交卷，请在考试过程中保证全屏模式。",
            onOk: () => {
              var path = that.$route.path;
              if (path.indexOf("Examination") === 1) {
                that.launchFullscreen();
              }
            }
          });
        } else {
          //强制交卷
          that.forceSendAnswer();
        }
      }
    },
    loadanswered(dataList) {
      //  初始化答案数组
      var that = this;
      var topicId = 0;
      var tmp = [];
      for (var i = 0; i < dataList.length; i++) {
        tmp[i] = [];
        for (var j = 0; j < dataList[i].questionList.length; j++) {
          dataList[i].questionList[j].topicId = topicId;
          topicId++;
          var answeredTmp = {
            examQuestionId: dataList[i].questionList[j].examQuestionId, //题目id
            userAnswer: "", //单选和判断答案 选项id顺序
            userAnswers: [] //多选题答案 选项id顺序
          };
          tmp[i].push(answeredTmp);
        }
      }
      that.answerList = tmp;
      return dataList;
    },
    creatRandom() {
      //生成随机数 --每隔五分钟截图一次（1至5分钟随机拍照一次）
      var unitTime = 2 * 60;
      var Rand = Math.random();
      Rand = Math.round(Rand * unitTime);
      return Rand;
    },
    openCamera() {
      var that = this;
      // 老的浏览器可能根本没有实现 mediaDevices，所以我们可以先设置一个空的对象
      if (navigator.mediaDevices === undefined) {
        navigator.mediaDevices = {};
      }
      if (navigator.mediaDevices.getUserMedia === undefined) {
        navigator.mediaDevices.getUserMedia = function(constraints) {
          // 首先，如果有getUserMedia的话，就获得它
          var getUserMedia =
            navigator.webkitGetUserMedia ||
            navigator.mozGetUserMedia ||
            navigator.msGetUserMedia;
          // 一些浏览器根本没实现它 - 那么就返回一个error到promise的reject来保持一个统一的接口
          if (!getUserMedia) {
            return Promise.reject(
              new Error("getUserMedia is not implemented in this browser")
            );
          }
          // 否则，为老的navigator.getUserMedia方法包裹一个Promise
          return new Promise(function(resolve, reject) {
            getUserMedia.call(navigator, constraints, resolve, reject);
          });
        };
      }
      //调用摄像头的主体部分
      var cameraOptions = {
        video: true,
        audio: false
      };
      var promise = navigator.mediaDevices.getUserMedia(cameraOptions);
      promise
        .then(function(stream) {
          //成功调用后回调函数
          var aVideo = $("#video")[0];
          try {
            aVideo.srcObject = stream;
          } catch (error) {
            aVideo.src = URL.createObjectURL(stream);
          }
          aVideo.onerror = function() {
            stream.stop();
            window.clearTimeout(that.screenShotTime);
          };
          aVideo.onended = function() {
            stream.stop();
            window.clearTimeout(that.screenShotTime);
          };
          aVideo.onloadedmetadata = function() {
            var msg =
              "摄像头设备检测到可以正常使用，请保持此状态，确保考试作答可以正常进行.";
            that.$Message.success({
              content: msg,
              duration: 5
            });
            aVideo.play();
            that.randScreenShot(that.creatRandom());
          };
        })
        .catch(function(err) {
          //调用失败后的回调函数---需要做对应的处理
          var msg = "";
          that.takePhoto = true;
          switch (err.name) {
            case "NotAllowedError":
              msg = "请在浏览器相关设置里允许该网页使用摄像头.";
              break;
            case "AbortError":
              msg =
                "摄像被阻止使用,假如您的操作没有不当的地方.建议换一台设备进行操作";
              break;
            case "NotFoundError":
              msg = "没有找到摄像头设备。建议换一台设备进行操作";
              break;
            case "NotReadableError":
              msg =
                "虽然您已授予使用匹配设备的权限，但操作系统，浏览器或网页级别发生硬件错误，导致无法访问设备。建议换一台设备进行操作。";
              break;
            case "OverconstrainedError":
              msg =
                "指定的约束导致没有符合所请求标准的候选设备。建议换一台设备进行操作";
              break;
            case "SecurityError":
              msg = "该摄像头对象禁用用户媒体支持,建议换一台设备进行操作";
              break;
            case "TypeError":
              console.log(err);
              msg = "指定的约束列表为空,请联系技术人员.";
              break;
          }
          that.$Message.error({
            content: msg,
            duration: 5
          });
          that.$router.push("/Online");
        });
    },
    randScreenShot(shotTime) {
      //随机截图
      console.log("随机截图");
      var that = this;
      var path = that.$route.path;
      console.log("随机数为" + shotTime);
      console.log("时间为" + that.goTime);
      console.log(path.indexOf("Examination") === 1, 666777);
      that.screenShotTime = window.setTimeout(function() {
        if (path.indexOf("Examination") === 1) {
          if (that.ShotCount <= 4 && that.goTime <= 600) {
            console.log(that.countTimeout, 11);
            console.log("时间为" + that.goTime);
            console.log("我是十分钟拍5张");
            that.screenshot();
            that.randScreenShot(that.creatRandom());
          } else if (4 <= that.ShotCount && that.goTime <= 600) {
            console.log("我是十分钟拍完了5张");
            that.randScreenShot(that.creatRandom());
          } else {
            console.log("我是大于十分钟");
            that.screenshot();
            that.randScreenShot(that.creatRandom());
          }
        }
      }, shotTime * 1000);
    },
    screenshot() {
      var that = this;
      console.log("拍照！！");
      //清除上一个定时器
      window.clearTimeout(that.screenShotTime);
      // 截图功能
      var aVideo = $("#video")[0];
      var aCanvas = $("#canvas")[0];
      var ctx = aCanvas.getContext("2d");
      ctx.drawImage(aVideo, 0, 0, 240, 180); //将获取视频绘制在画布上
      var img = aCanvas.toDataURL("image/png");
      var modelData = {
        data: img,
        examId: that.$route.params.examId
      };
      that
        .$http({
          url: that.webhost + "exam/takePhoto",
          method: "POST",
          data: modelData
        })
        .then(({ data }) => {
          if (data && data.code === 0) {
            that.ShotCount = data.data;
            console.log("第" + that.ShotCount + "次拍");
          } else {
            that.$Message.error(data.msg);
          }
        });
    },
    examEnd() {
      var that = this;
      that.resultDialog = false; //关闭弹窗
      that.$router.go(0); //返回页面
    },
    //查看成绩modal
    checkGrade() {
      var that = this;
      var modelData = {
        answerList: that.answerData,
        examId: that.examId
      };
      // 请求查看成绩的地址
      that
        .$http({
          url:
            that.webhost +
            "exam/queryScore?idCard=" +
            JSON.parse(that.$cookie.get("xjaf-user")).idCard,
          method: "POST",
          data: modelData
        })
        .then(({ data }) => {
          console.log("第二次请求", data);
          if (data && data.code === 0) {
            if (data.data.score === null) {
              alert("后台还在评卷中，请稍后再试！");
            } else {
              that.result = data.data;
              that.$cookie.delete("checkCount");
              that.showModal = false; //移除modal
              var path = that.$route.path;
              if (path.indexOf("Examination") === 1) {
                that.resultDialog = true;
              }
            }
          } else {
            // that.$Message.error(data.msg);
            that.$Modal.warning({
              title: "考试警告",
              content: data.msg,
              onOk: () => {}
            });
          }
        });
    },
    forceSendAnswer() {
      // 强制交卷
      var that = this;
      that.showSubBtn = false;
      var modelData = {
        answerList: that.answerData,
        examId: that.examId
      };
      that.$Spin.show({
        render: h => {
          return h("div", [
            h("Icon", {
              class: "demo-spin-icon-load",
              props: {
                type: "ios-loading",
                size: 18
              }
            }),
            h("div", "考试已结束，正在提交卷请等待!")
          ]);
        }
      });
      that
        .$http({
          url: that.webhost + "exam/submitAnswer",
          method: "POST",
          data: modelData
        })
        .then(
          ({ data }) => {
            console.log("第一次请求", data);
            that.$Spin.hide();
            if (data && data.code === 0) {
              window.clearTimeout(that.screenShotTime);
              that.showModal = true; //若没有返回成绩则显示另一个提示框
            } else {
              // that.$Message.error(data.msg);
              that.$Modal.warning({
                title: "提交失败，确定后重新提交！",
                content: data.msg,
                onOk: () => {
                  that.$Spin.hide();
                  that.forceSendAnswer();
                }
              });
            }
          },
          data => {
            that.autoSend = setTimeout(() => {
              // that.$Spin.hide();
              that.forceSendAnswer2();
            }, 2000);
          }
        );
    },
    forceSendAnswer2() {
      // 强制交卷
      var that = this;

      clearTimeout(that.autoSend);
      var modelData = {
        answerList: that.answerData,
        examId: that.examId
      };
      that.$Spin.hide();
      that.$Spin.show({
        render: h => {
          return h("div", [
            h("Icon", {
              class: "demo-spin-icon-load",
              props: {
                type: "ios-loading",
                size: 18
              }
            }),
            h("div", "您的网络不稳定，提交失败，正在重新提交!")
          ]);
        }
      });
      that
        .$http({
          url: that.webhost + "exam/submitAnswer",
          method: "POST",
          data: modelData
        })
        .then(
          ({ data }) => {
            console.log("第一次请求", data);
            that.$Spin.hide();
            if (data && data.code === 0) {
              window.clearTimeout(that.screenShotTime);
              that.showModal = true; //若没有返回成绩则显示另一个提示框
            } else {
              // that.$Message.error(data.msg);
              that.$Modal.warning({
                title: "提交失败，确定后重新提交！",
                content: data.msg,
                onOk: () => {
                  that.$Spin.hide();
                  that.forceSendAnswer();
                }
              });
            }
          },
          data => {
            that.autoSend = setTimeout(() => {
              // that.$Spin.hide();
              that.forceSendAnswer2();
            }, 2000);
          }
        );
    },
    sendAnswer() {
      var that = this;
      window.clearTimeout(that.countTimeout);
      //正常交卷
      if (that.handinflag == 0) {
        that.handinflag = 1;
        that.showSubBtn = false;
        var modelData = {
          answerList: that.answerData,
          examId: that.examId
        };
        // console.log(that.answerData)
        that.$Spin.show({
          render: h => {
            return h("div", [
              h("Icon", {
                class: "demo-spin-icon-load",
                props: {
                  type: "ios-loading",
                  size: 18
                }
              }),
              h("div", "卷子已提交，系统正在对比考试成绩，请您稍等！")
            ]);
          }
        });
        that
          .$http({
            url: that.webhost + "exam/submitAnswer",
            method: "POST",
            data: modelData
          })
          .then(
            ({ data }) => {
              console.log(data, data.data);
              that.$Spin.hide();
              if (data && data.code === 0) {
                window.clearTimeout(that.screenShotTime);
                that.isSelfSend = 1;
                that.answerDuration = 0;
                that.showModal2 = true;
              }else if(data && data.code === 1001) {
                that.$Message.error("试卷出错，请联系管理员！");
              }else {
                that.$Modal.warning({
                  title: "考试警告",
                  content: "提交失败，确定后重新提交！",
                  onOk: () => {
                    that.$Spin.hide();
                    that.handinflag = 0;
                    that.sendAnswer();
                  }
                });
              }
            },
            data => {
              // that.$Message.error('您的网络不稳定提交失败，正在重新提交');
              that.autoSend = setTimeout(() => {
                that.handinflag = 0;
                that.sendAnswer2();
              }, 2000);
            }
          );
      } else {
        that.$Message.error("请勿重复提交成绩");
      }
    },
    sendAnswer2() {
      var that = this;

      clearTimeout(that.autoSend);
      //正常交卷--断网重新提交
      if (that.handinflag == 0) {
        that.handinflag = 1;
        var modelData = {
          answerList: that.answerData,
          examId: that.examId
        };
        // console.log(that.answerData)
        that.$Spin.hide();
        that.$Spin.show({
          render: h => {
            return h("div", [
              h("Icon", {
                class: "demo-spin-icon-load",
                props: {
                  type: "ios-loading",
                  size: 18
                }
              }),
              h("div", "您的网络不稳定，提交失败，正在重新提交！")
            ]);
          }
        });
        that
          .$http({
            url: that.webhost + "exam/submitAnswer",
            method: "POST",
            data: modelData
          })
          .then(
            ({ data }) => {
              console.log(data, data.data);
              that.$Spin.hide();
              if (data && data.code === 0) {
                window.clearTimeout(that.screenShotTime);
                that.isSelfSend = 1;
                that.answerDuration = 0;
                that.showModal2 = true;
              } else {
                that.$Modal.warning({
                  title: "考试警告",
                  content: "提交失败，确定后重新提交！",
                  onOk: () => {
                    that.$Spin.hide();
                    that.handinflag = 0;
                    that.sendAnswer();
                  }
                });
              }
            },
            data => {
              that.autoSend = setTimeout(() => {
                // that.$Spin.hide();
                that.handinflag = 0;
                that.sendAnswer2();
              }, 2000);
            }
          );
      } else {
        that.$Message.error("请勿重复提交成绩");
      }
    }
  },
  components: {
    Footer
  }
};
</script>
<style scoped>
.anchor {
  position: absolute;
  top: -65px;
}

.wrapper {
  width: 1200px;
  min-width: 1200px;
  margin: 0 auto;
  margin-bottom: 90px;
  font-family: "PingFang SC";
}

.title {
  text-align: left;
  font-size: 25px;
  line-height: 72px;
  color: #000;
  border-bottom: solid 2px #ccc;
}

.header {
  position: fixed;
  top: 0;
  z-index: 999;
  width: 1200px;
  background: #23b8ff;
  color: #fff;
  font-size: 19px;
  line-height: 65px;
  padding: 0 12px;
  font-weight: bold;
}

.inner-wrapper {
  width: 930px;
  padding: 20px;
}

.title2 {
  margin-top: 65px;
  font-size: 19px;
  color: #000;
}

.subject {
  padding: 15px 0;
}

.question {
  position: relative;
  color: #333;
  font-size: 17px;
  line-height: 35px;
}

.options span {
  font-size: 16px;
  line-height: 30px;
  position: relative;
  top: 2px;
  padding-left: 10px;
}

.double,
.judge {
  margin-top: 20px;
}

.submit {
  margin-top: 50px;
}

.submit button {
  width: 140px;
  background: #23b8ff;
  font-size: 17px;
  border-color: #23b8ff;
}

.All {
  position: absolute;
  z-index: 999;
  top: 90px;
  right: 0px;
  width: 250px;
  min-height: 150px;
  line-height: 30px;
  color: #000;
  /*background: #f1f1f1;*/
}

.All .videoM,
.All .sum {
  box-shadow: 0 1px 10px 3px rgba(0, 0, 0, 0.1);
}

.All .videoM {
  background-color: #fff;
}

.All .sum {
  margin-top: 30px;
  padding: 5px;
  background: #87ceff;
  color: #2d8cf0;
  box-shadow: 0 1px 10px 3px rgba(0, 0, 0, 0.1);
}

.All .sum .col-10 {
  display: inline-block;
  /*height: 15px;*/
  font-size: 13px;
}

.answerBlue {
  color: #000;
}

.videoM .video {
  margin: 10px auto;
}

.videoM p {
  display: block;
  width: 90%;
  margin: 5px auto;
  color: #dd6161;
  font-size: 13px;
}

.resultlist {
  width: 360px;
  margin: auto;
  overflow: hidden;
}

.result {
  font-size: 20px;
  width: 120px;
  float: left;
}

.remark {
  margin-top: 20px;
  font-weight: bolder;
  color: #006ffd;
}
>>> .ivu-message {
  z-index: 9999 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/Examination.vue